import { createContext, useContext } from 'react';

import { type IPaymentIntegration, createIntegration } from '@endeavour/payment-integration';

const noProviderError = () => {
    throw new Error('Provider has not been initialized');
};

const DEFAULT_CONTEXT: IPaymentIntegration<unknown> = createIntegration({
    name: 'missing-provider',
    cancelWithdrawal: noProviderError,
    getMethods: noProviderError,
    getHostedField: noProviderError,
    getSavedAccounts: noProviderError,
    getPendingWithdrawals: noProviderError,
    getMethodDetailsForm: noProviderError,
    processPayment: noProviderError,
    initialize: noProviderError,
    destroy: noProviderError,
});

const PaymentProviderContext = createContext(DEFAULT_CONTEXT);

export const PaymentIntegrationProvider = PaymentProviderContext.Provider;

export function useProviderIntegration() {
    const context = useContext(PaymentProviderContext);
    return context;
}
